import { render, staticRenderFns } from "./mentor.vue?vue&type=template&id=30d5714f&scoped=true"
import script from "./mentor.vue?vue&type=script&lang=js"
export * from "./mentor.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home.css?vue&type=style&index=0&id=30d5714f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d5714f",
  null
  
)

export default component.exports